import { BusinessSettingsLayout } from '@/components/business-settings/BusinessSettingsLayout';
import { HolidayCalendar } from '@/components/business-settings/HolidayCalendar';
import { useCompanySettings } from '@/hooks/useCompanySettings';

export default function HolidaySettings() {
  const { settings: companySettings, updateSettings: updateCompanySettings } = useCompanySettings();

  return (
    <BusinessSettingsLayout
      title="Holidays"
      description="Manage company holidays and public holiday calendars"
    >
      <HolidayCalendar
        holidays={(companySettings?.holidays as string[]) || []}
        countryCode={companySettings?.country_code || null}
        regionCode={companySettings?.region_code || null}
        holidaySyncStatus={companySettings?.holiday_sync_status || null}
        holidayAutoSync={companySettings?.holiday_auto_sync ?? false}
        onAutoSyncChange={async (enabled) => {
          await updateCompanySettings({ holiday_auto_sync: enabled });
        }}
        onSave={async (holidays, additionalUpdates) => {
          await updateCompanySettings({ 
            holidays, 
            ...additionalUpdates
          });
        }}
        onCountryChange={async (countryCode) => {
          await updateCompanySettings({ country_code: countryCode });
        }}
        onRegionChange={async (regionCode) => {
          await updateCompanySettings({ region_code: regionCode });
        }}
        isLoading={false}
      />
    </BusinessSettingsLayout>
  );
}
